module.exports = __webpack_public_path__ + "media/images/form_component_sprite_2x-094f625b414eede4921584c83055ba91.png";